import React from 'react';
import styled from 'styled-components'

const TabContainer = styled.div`
    height: ${props=> props.height-85+"px"};
    /* border:1px solid yellow; */

    font-family: SourceSansPro-Regular,Arial,Helvetica Neue,Helvetica,sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #364159;
    font-weight:normal;
`
export default TabContainer;